<script>
   /**************************************************************/
   /* Svelte component for selection of a component              */
   /**************************************************************/

   import { Container as ControlElementContainer, Range } from '.';

   export let model;
   export let value = 1;
   export let label = '# PCs';
</script>

{#if model}
<ControlElementContainer {label}>
<Range id="ncomp" bind:value min={1} max={model.ncomp} step={1} decNum={0}/>
</ControlElementContainer>
{/if}

